import { observable, runInAction } from 'mobx'
import { birthDate } from '../hooks/dateOutputs'
import GlobalState from './GlobalState'
type User = {
  id: number
  phone: ''
  email: ''
  birthDate: ''
  docLang: ''
  name: ''
  surname: ''
  lastname: ''
} | null

type UserModelType = {
  user: User
  codes: string
}

type AccountModelType = {
  email: string | null
}

const UserModel: UserModelType = observable({
  user: null,
  codes: '',
})

export const AccountModel: AccountModelType = observable({
  email: null,
})

export const setUser = (email: string) => {
  localStorage.setItem('user-np', email)
  runInAction(() => {
    AccountModel.email = email
  })
}

export const login = async (cods: string, phone: string) => {
  try {
    const fd = new FormData()
    fd.append('phone', phone.replaceAll('+', '').replaceAll('-', ''))
    fd.append('cods', cods)
    fd.append('status', 'login')
    const request = await fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    })
    const response = await request.json()

    console.log(response)
    runInAction(() => {
      UserModel.user = response
    })
  } catch (e) {
    console.log(e)
  }
}

export const oldLogin = async (
  email: string,
  password: string,
  token: string,
) => {
  try {
    const fd = new FormData()
    fd.append('email', email)
    fd.append('password', password)
    fd.append('token', token)
    fd.append('status', 'old-login')
    const request = await fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    })
    const response = await request.json()
    return response
  } catch (e) {
    console.log(e)
  }
}

export const changePass = async (email: string) => {
  try {
    const fd = new FormData()
    fd.append('email', email)
    fd.append('status', 'change-pass')
    const request = await fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    })
    const response = await request.json()
  } catch (e) {
    console.log(e)
  }
}

export const regOld = async (
  email: string,
  password: string,
  token: string,
) => {
  try {
    const fd = new FormData()
    fd.append('email', email)
    fd.append('password', password)
    fd.append('token', token)
    fd.append('status', 'old-reg')
    const request = await fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    })
    const response = await request.json()
    return response
  } catch (e) {
    console.log(e)
  }
}

export const updateOld = async (
  email: string,
  name: string,
  lastname: string,
  phone: string,
  country: string,
) => {
  try {
    const fd = new FormData()
    fd.append('email', email)
    fd.append('user_name', name)
    fd.append('lastname', lastname)
    fd.append('country', country)
    fd.append('phone', phone)
    fd.append('status', 'old-update')
    const request = await fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    })
    const response = await request.json()

    runInAction(() => {
      UserModel.user = response
    })
  } catch (e) {
    console.log(e)
  }
}

export const sendCods = async (phone: string) => {
  try {
    const fd = new FormData()
    fd.append('phone', phone.replaceAll('+', '').replaceAll('-', ''))
    fd.append('status', 'login-cods')
    const request = await fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    })
    const response = await request.json()

    runInAction(() => {
      UserModel.user = response
      UserModel.codes = response
    })
  } catch (e) {
    console.log(e)
  }
}

export const sendRegCods = async (phone: string) => {
  try {
    const fd = new FormData()
    fd.append('phone', phone)
    fd.append('status', 'reg-cods')
    const request = await fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    })
    const response = await request.json()

    runInAction(() => {
      UserModel.user = response.user
      UserModel.codes = response.code
    })
  } catch (e) {
    console.log(e)
  }
}

export const update = async (dt: any) => {
  try {
    const fd = new FormData()
    fd.append('user_name', dt.name)
    fd.append('user_surname', dt.name)
    fd.append('phone', dt.phone)
    fd.append('email', dt.email)
    fd.append('doc_lang', dt.docLang)
    fd.append('date_birth', `${birthDate(dt.date, dt.month, dt.year)}`)
    fd.append('status', 'update-reg')
    await fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    })
  } catch (e) {
    console.log(e)
  }
}

export default UserModel
